export * from './partnersQueries';